/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartGroupModifierSchema } from "./banquetCartGroupModifierSchema.ts";
import { banquetCartModifierSchema } from "./banquetCartModifierSchema.ts";

export const banquetCartItemSchema = z.object({
	id: z.uuid(),
	amount: z.int(),
	size: z.uuid().nullable(),
	comment: z.string().nullable(),
	modifiers: z.array(banquetCartModifierSchema),
	group_modifiers: z.array(banquetCartGroupModifierSchema),
});
